// 地图
const mapDialog = {
  state: {
    mapDialogIsFirst: true,
    mapDialogState: false,
    mapDialogLng: '', // 经度
    mapDialogLat: '', // 维度
    mapDialogStr: '', // 地址汉字

    mapDialogJWD: '' // 经纬度字符串
    // hddIds: '',
    // hddNames: ''
  },
  mutations: {
    SET_MAPDIALOGISFIRST: (state, mapDialogIsFirst) => {
      state.mapDialogIsFirst = mapDialogIsFirst
    },
    SET_MAPDIALOGSTATE: (state, mapDialogState) => {
      state.mapDialogState = mapDialogState
    },
    SET_MAPDIALOGLNG: (state, mapDialogLng) => {
      state.mapDialogLng = mapDialogLng
    },
    SET_MAPDIALOGLAT: (state, mapDialogLat) => {
      state.mapDialogLat = mapDialogLat
    },
    SET_MAPDIALOGSTR: (state, mapDialogStr) => {
      state.mapDialogStr = mapDialogStr
    },
    SET_MAPDIALOGJWD: (state, mapDialogJWD) => {
      state.mapDialogJWD = mapDialogJWD
    }
    // SET_HDDIDS: (state, hddIds) => {
    //   state.hddIds = hddIds
    // },
    // SET_HDDNAMES: (state, hddNames) => {
    //   state.hddNames = hddNames
    // }
  
  },
  actions: {
  }
}

export default mapDialog
